//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_SOCIOS_EXTRANJEROS = "obtenerSociosExtranjeros";
export const OBTENER_SOCIO_EXTRANJERO = "obtenerSocioExtranjero";
export const OBTENER_SOCIO_EXTRANJERO_DESCRIPCIONES = "obtenerSocioExtranjeroDescripciones";
export const REGISTAR_SOCIO_EXTRANJERO = "registrarSocioExtranjero";
export const ACTUALIZAR_SOCIO_EXTRANJERO = "actualizarSocioExtranjero";
// mutation types
export const SET_SOCIOS_EXTRANJEROS = "setEmpresas";
export const SET_SOCIO_EXTRANJERO = "setEmpresa";

const state = {
    sociosExtranjeros: [],
    socioExtranjero:[],
}

const getters = {
    obtenerSociosExtranjeros(state) {
      return state.sociosExtranjeros;
    },
}

const actions = {
    async [OBTENER_SOCIOS_EXTRANJEROS](context) {

        return new Promise(resolve => {
            ApiService.query("apiconsume/obtener?endpoint=api/Socio_Extranjero", '')
                .then(({ data }) => {
                    context.commit(SET_SOCIOS_EXTRANJEROS, data.data);
                    //console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });       
    },

    

    async [OBTENER_SOCIO_EXTRANJERO](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Socio_Extranjero/`)
                .then(({ data }) => {
                    context.commit(SET_SOCIO_EXTRANJERO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    /**
     * Obtener los datos de un socio extranjero con los valores que corresponden a cada foranea
     * @param {*} context 
     * @param {*} id 
     * @returns 
     */
    async [OBTENER_SOCIO_EXTRANJERO_DESCRIPCIONES](context, id){
        
        return new Promise(resolve => {
            ApiService.query(`apiconsume/edit/${id}?endpoint=api/Socio_Extranjero/GetByIdDatosSocioExtranjero/`)
                .then(({ data }) => {
                    context.commit(SET_SOCIO_EXTRANJERO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    


    },

    

    async [REGISTAR_SOCIO_EXTRANJERO](context, datosEmpresa){
        
        //console.log(datosEmpresa)
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Socio_Extranjero`, datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_SOCIO_EXTRANJERO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },
    
    async [ACTUALIZAR_SOCIO_EXTRANJERO](context, datos){
        let id = datos.id;
        
        return new Promise(resolve => {
            ApiService.post(`apiconsume/update/${id}?endpoint=api/Socio_Extranjero/UpdateSocio_Extranjero/`, datos.datosEmpresa)
                .then(({ data }) => {
                    context.commit(SET_SOCIO_EXTRANJERO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    }

  }

const mutations = {
    [SET_SOCIOS_EXTRANJEROS](state, data) {
        state.sociosExtranjeros = data;
    },

    [SET_SOCIO_EXTRANJERO](state, data) {
        state.socioExtranjero = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}